import React, { useState } from "react";
import { FaUserTie, FaArrowUp, FaArrowDown } from "react-icons/fa";
import { Header, DateRangePicker } from "../../../components/ui";
import PageLayout from "../../../components/layout/PageLayout";
import api from "../../../services/api";

export default function DriverStatsPage() {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortKey, setSortKey] = useState("percentCompleted");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleRangeChange = async ({ from, to }) => {
    if (!from || !to) return;
    setLoading(true);
    try {
      const data = await api.post("/analytics/drivers", { from, to });
      setDrivers(Array.isArray(data) ? data : []);
    } finally {
      setLoading(false);
    }
  };

  const totalDrivers = drivers.length;
  const totalRoutes = drivers.reduce((a, d) => a + (d.routes || 0), 0);
  const totalReceipts = drivers.reduce((a, d) => a + (d.receiptsTotal || 0), 0);

  return (
    <PageLayout
      header={
        <Header
          icon={FaUserTie}
          title="Эффективность водителей"
          subtitle="Статистика и показатели за выбранный период"
        />
      }
      controls={<DateRangePicker mode="range" onChange={handleRangeChange} />}

    >
      {loading ? (
        <p>Загрузка данных...</p>
      ) : drivers.length === 0 ? (
        <p>Нет данных за выбранный период.</p>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "0.8rem" }}>
          {drivers.map((d, i) => (
            <DriverCard key={i} data={d} />
          ))}
        </div>
      )}
    </PageLayout>
  );
}

function DriverCard({ data }) {
  const getColor = (p) =>
    p >= 90 ? "#4caf50" : p >= 70 ? "#ffc107" : p >= 50 ? "#ff9800" : "#f44336";

  return (
    <div
      style={{
        position: "relative", // ✅ добавлено — теперь полоска знает границы
        background: "#fff",
        borderRadius: "0.6rem",
        padding: "0.8rem 1rem 1.2rem",
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        overflow: "hidden", // чтобы линия не выходила за рамки
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "0.5rem",
        }}
      >
        <div style={{ fontWeight: 600 }}>{data.name}</div>
        <div style={{ fontWeight: 700, color: getColor(data.percentCompleted) }}>
          {data.percentCompleted}%
        </div>
      </div>

      <div style={{ fontSize: "0.9rem", color: "#444", lineHeight: "1.6em" }}>
        <div>
          Маршруты: <b>{data.routes}</b>
        </div>
        <div>
          Квитанции: <b>{data.receiptsTotal}</b>
        </div>
        <div>
          Закрыто: <b>{data.completed}</b>
        </div>
        <div>
          Открыто: <b>{data.open}</b>
        </div>
        <div>
          Не доставлено: <b>{data.failed}</b>
        </div>
      </div>

      {/* === Индикатор выполнения === */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          height: "6px",
          width: `${data.percentCompleted}%`,
          background: getColor(data.percentCompleted),
          borderBottomLeftRadius: "0.6rem",
          borderBottomRightRadius:
            data.percentCompleted === 100 ? "0.6rem" : "0",
          transition: "width 0.4s ease",
        }}
      />
    </div>
  );
}